__turbopack_context__.v({
  "aiBtn": "AiSuggestionSection-module__SUFovG__aiBtn",
  "bigTitle": "AiSuggestionSection-module__SUFovG__bigTitle",
  "desc": "AiSuggestionSection-module__SUFovG__desc",
  "leftCol": "AiSuggestionSection-module__SUFovG__leftCol",
  "rightCol": "AiSuggestionSection-module__SUFovG__rightCol",
  "section": "AiSuggestionSection-module__SUFovG__section",
});
